import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class CustomerAverageAnnualDeliveredUnitsService {
	private httpClient = inject(HttpClient);

	get(subscriberKey: number, productCategoryCostKey: number, hierarchyNodeKeys: number[]) {

        const body = {
            productCategoryCostKey,
            hierarchyNodeKeys,
        }

			return this.httpClient.post<number>(
                `api/subscriber/${subscriberKey}/deliveries/reports/customer-average-annual-units`,body);
		}
}
